export function isNullOrEmpty(value: any): boolean {
  return (
    typeof value === 'undefined' ||
    value == null ||
    (typeof value === 'string' && value === '')
  );
}
